module.exports = __webpack_public_path__ + "img/banner_doc.61caa27d.png";